import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListAgencyProducers from './ListAgencyProducers'
import ShowAgencyProducerPage from './ShowAgencyProducerPage'
import NewAgencyProducerPage from './NewAgencyProducerPage'
import EditAgencyProducerPage from './EditAgencyProducerPage'

const AgencyProducers = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListAgencyProducers} />
    <Route exact path={match.url + '/new'} component={NewAgencyProducerPage} />
    <Route path={match.url + '/:id/edit'} component={EditAgencyProducerPage} />
    <Route path={match.url + '/:id'} component={ShowAgencyProducerPage} />
  </Switch>
)

export default AgencyProducers



// WEBPACK FOOTER //
// ./src/components/AgencyProducers/AgencyProducers.jsx